import { render } from "./BucketTotal.vue?vue&type=template&id=6abaf4df&scoped=true&ts=true"
import script from "./BucketTotal.vue?vue&type=script&lang=ts"
export * from "./BucketTotal.vue?vue&type=script&lang=ts"

import "./BucketTotal.vue?vue&type=style&index=0&id=6abaf4df&scoped=true&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abaf4df"]])

export default __exports__